const team = {
    currentMembers: {
        doctoralStudents: [
            {
                src: 'images/members/ghora.jpg',
                text: 'Santanu Ghora is from Purba Medinipur, West Bengal, India. He completed his B.Sc. in Chemistry from Jadavpur University in 2017, followed by an M.Sc. in Chemistry from IIT Hyderabad in 2019. In the same year, he joined the Department of Chemistry at IIT Kharagpur as a UGC-CSIR fellow to pursue his Ph.D under the guidance of Prof. C. Retna Raj. His research primarily focuses on the synthesis and characterization of advanced electrocatalysts, such as intermetallics and transition metal phosphides, with applications in high-performance zinc-air batteries and catalytic systems. Contact Info: Santanuchem96@gmail.com',
            },
            {
                src: 'images/members/akash.jpg',
                text: 'Akash Paswan is from Kalyan, Maharashtra. He completed his B.Sc. in Chemistry from C.K.T. College, Mumbai University, in 2016, followed by an M.Sc. in Chemistry from Mumbai University in 2018. After working for a year at Asian Paints, he joined IIT Kharagpur as a UGC-CSIR Ph.D scholar in 2020. His research focuses on anode modification to enhance the cycling stability of zinc batteries.contact Info: akashp136@gmail.com',
            },
            {
                src: 'images/members/thapa.jpg',
                text: 'Loknath Thapa completed his B.Sc. from Dibrugarh University in 2017 and M.Sc. from NIT Meghalaya in 2019. He joined in December 2020, currently working as Institute Fellow. His research primarily focuses on developing functional materials for electrocatalysis. He works on electrolyzers that pair anodic oxidation with cathodic reduction reactions to produce valuable chemicals at the cathode and anode simultaneously. Cotact Info: loknathchem@gmail.com',
            },
            {
                src: 'images/members/sudip.jpg',
                text: 'Sudip Mallobarman is from North 24 Parganas, West Bengal. He completed his B.Sc. from Barasat Government College under West Bengal State University, graduating in 2020. He then earned his M.Sc. from IIT ISM Dhanbad, graduating in 2022. In 2023, he joined the Department of Chemistry at IIT Kharagpur as a Institute Fellow. His research focuses on Valuable chemical electrosynthesis using aqueous electrolytes. Contact Info: Sdpmllbrmn@gmail.com',
            },
            {
                src: 'images/members/Sakil.jpg',
                text: 'Sakil Mallick is from Purba Medinipur, West Bengal. He completed his B.Sc. in Chemistry from Midnapore College, in 2019, followed by an M.S. in Chemistry from IISER, Mohali in 2022. He joined ICMS Unit at JNCASR for a PGDMS diploma. He worked as a Project-JRF at the Department of Chemical Engineering in IIT Kharagpur. He joined Department of Chemistry as an Institute Fellow in June 2025. His research focuses on anode and electrolyte engineering.contact Info: Sakiliiser07@gmail.com',
            },
            {
                src: 'images/members/Aritra Mondal.jpg',
                text: 'Aritra Mondal is from South 24 Pgs, West Bengal. He completed his B.Sc. Chemistry (Hons) from Calcutta University in 2023 and M.Sc. Chemistry from NIT Surathkal, Karnataka, in 2025. He joined in July 2026 and is currently working as an institute fellow. His research mainly focuses on electrocatalysis . Contact Info: aritram998@gmail.com',
            },
        ],
        mastersStudents: [
            {
                src: 'images/members/Sudhanshu.jpg',
                text: 'Sudhanshu Singh Rajput is from Varanasi, Uttar Pradesh. He is a Masters student having major in Chemistry at IIT KGP . His primary research interests lie in the fields of electrochemistry and electrocatalysis, specifically in OER/ORR studies.',
            },
            {
                src: 'images/members/Biswajeet.jpeg',
                text: 'Korabu Biswajeet Naidu is from Malkangiri, Odisha, India. He joined IIT Kharagpur in 2022 as an undergraduate student in the Department of Chemistry and is currently enrolled in the BS-MS programme. He is currently working on his Masters thesis project, Electrochemical Upcycling of Plastics to Value-Added Products, under the guidance of Prof. C. Retna Raj. Contact Info: korabubiswajeetnaidu0@gmail.com',
            },
        ],
        postDocStudents: [
            {
                src: 'images/members/Krishnendu Bera.jpeg',
                text: 'Dr. Krishnendu Bera is from Paschim Medinipur, West Bengal. He received his B.Sc degree from Ramakrishna Mission Vivekananda Centenary college (Rahara, West Bengal) affiliated with West Bengal State University (2018) and obtained his M.Sc degree in from the Same University (2020) with specialization in ‘Physical Chemistry’. While pursuing his MSc, he was qualified for the NET (National Level Eligibility Test), 2019 June and JRF (Junior Research fellowship) from CSIR, New Delhi. He completed his Ph.D from CSIR-CECRI and his Ph.D thesis focused on “Development of non-precious transition metal based electrocatalysts for water splitting application”. He worked as a Research Associate-I at IIT (ISM) Dhanbad and has now joined the Chemistry Department as an I-PDF. His current research is dedicated to scaling up green hydrogen production for industrial applications. Contact Info:krishbera1997@gmail.com'
            },   
        ],
        interns: [   
        ], // Placeholder for future data
    },
    pastMembers: {
        doctoralStudents: [
            {
                name: "Dr. Saheb Bag",
                details: ""
            },
            {
                name: "Dr. Manikanta Kumar Mopidevi",
                details: "Post-doc, IIT Bombay"
            },
            {
                name: "Dr. Sourav Mallick",
                details: "Associate Manager, Adani Group"
            },
            {
                name: "Dr. Sukanta Chakrabartty",
                details: "Assistant Professor, VIT Vellore"
            },
            {
                name: "Dr. Arpan Samanta",
                details: "Research Associate, Shell Technology Centre, Bangalore"
            },
            {
                name: "Dr. Siniya Mondal",
                details: "Post-doc, Tokyo University"
            },
            {
                name: "Dr. Bhaskar Manna",
                details: ""
            },
            {
                name: "Dr. Sourav Bag",
                details: "Assistant Professor,BITS Pilani"
            },
            {
                name: "Dr. Ashok Kumar Das",
                details: "Post-doc, Korea"
            },
            {
                name: "Dr. Raj Kumar Bera",
                details: "Flint, Singapore"
            },
            {
                name: "Dr. Sourov Ghosh",
                details: "Scientist, Fuel Cell R&D, Reliance"
            },
            {
                name: "Dr. Ramendra Sundar Dey",
                details: "Scientist, Institute of Nanoscience and Technology (INST), Mohali"
            },
            {
                name: "Dr. Sudip Chakraborty",
                details: "Teacher, WB"
            },
            {
                name: "Dr. Bikash Kumar Jena",
                details: "Scientist, CSIR- Institute of Minerals and Materials Technology, Bhubaneswar, Orissa"
            },
            {
                name: "Dr. Susmita Behera",
                details: "London, Brittain"
            }
        ],
        postDocStudents: [
            {
                name: "Dr. Sumanta Kumar Das",
                details: "Ben Guiron University, Israel"
            },
            {
                name: "Dr. Rishika Chakraborty",
                details: "Gdansk University of Technology, Poland"
            },
            {
                name: "Dr. Anirudha Kundu",
                details: "Assistant Professor, SRM University, Andhra Pradesh"
            },
            {
                name: "Dr. Barun Kumar Barman",
                details: "Assistant Professor, SRM University, Andhra Pradesh"
            },
        ],
        masterStudents: [
            {
                name: "Vinayaka S",
                details: "Faculty, Allen, Kota, Rajasthan"
            },
            {
                name: "Subhadip Bauri",
                details: "PhD, University of South Florida"
            },
            {
                name: "Bodhisatwa Mandi",
                details: "PhD, IIT Kharagpur"
            },
            {
                name: "Bikram Ghorai",
                details: ""
            },
            {
                name: "Prabir Biswas",
                details: "PhD, Indiana University"
            },
            {
                name: "Rahul Singh",
                details: "PhD,Casewestern University"
            },
            {
                name: "Manick Mistry",
                details: "PhD, IITKGP"
            },
            {
                name: "Somnath Bhattacharya",
                details: ""
            },
            {
                name: "Swarup Mallick",
                details: "PhD"
            },
            {
                name: "Manidipa Roy",
                details: "PhD"
            },
            {
                name: "Anurag Kumar",
                details: ""
            },
            {
                name: "Sayan Das",
                details: "PhD, JNCSAR"
            },
            {
                name: "Rahul Pan",
                details: "PhD, IIT Kgp"
            },
            {
                name: "Jai Shukla",
                details: "PhD, IIT Kgp"
            },
            {
                name: "Abhirup Bhadra",
                details: "PhD, UNSW, Australia"
            },
            {
                name: "Nikhil Mohan",
                details: "PhD, IIT Madras"
            },
            {
                name: "Amit Mondal",
                details: "PhD, IIT Kgp"
            },
            {
                name: "Damini Sahu",
                details: "PhD, IIT Bombay"
            },
            {
                name: "S. Majumdar",
                details: "PhD, Eindhoven University of Technology, Netherlands"
            },
            {
                name: "Arnab Ghatak",
                details: "PhD, IACS"
            },
            {
                name: "Subhajit Karmakar",
                details: "R&D, NFL"
            },
            {
                name: "Raghab Gorain",
                details: "Executive Officer, NTPC Ltd."
            },
            {
                name: "Dr. Chandan Sahu",
                details: "Scientific Officer, DAE"
            },
            {
                name: "Dr. Soumik Dinda",
                details: "N/A"
            },
            {
                name: "Dr. Rupankar Paira",
                details: "Assistant Professor, MMC College, Kolkata"
            },
        ],
        interns: [
            {
                name: "Korabu Biswajeet Naidu",
                details: "IIT Kharagpur"
            },
            {
                name: "Katravath Savitha",
                details: "IIT Kharagpur"
            },
            {
                name: "Deepthi R",
                details: "Central University of Kerala"
            },
            {
                name: "Amritpunya Mitra",
                details: "IACS, Kolkata"
            },
            {
                name: "Avik Mondal",
                details: "UoH, Hyderabad"
            },
            {
                name: "Dipanwita Chaulya",
                details: "IISER Bhopal, Bhopal"
            },
            {
                name: "Alok Barik",
                details: "NIIMS, Bhubaneswar"
            },
            {
                name: "Jaya Laxmi",
                details: ""
            },
            {
                name: "A Nimisha",
                details: ""
            },
        ],
    },
};

const homepageBannerImages = {
    carouselId: 'banner-image-info',
    details: [
        {
            id: 1,
            altText: 'First Slide',
            src: "images/homepage_banner_slide.png"
        },
        {
            id: 2,
            altText: 'Second Slide',
            src: "images/group-images1.jpg"
        },
        {
            id: 3,
            altText: 'Third Slide',
            src: "images/group-images2.jpg"
        },
        {
            id: 4,
            altText: 'Fourth Slide',
            src: "images/group-images3.jpg"
        },
        {
            id: 5,
            altText: 'Fifth Slide',
            src: "images/group-images4.jpg"
        },
        {
            id: 6,
            altText: 'Sixth Slide',
            src: "images/group-images5.jpg"
        },
        {
            id: 7,
            altText: 'Seventh Slide',
            src: "images/group-images6.jpg"
        },
    ]
}

const publications = {
    headingText: 'Recent publications',
    carouselId: 'publication-info',
    details: [
        {
            id: 1,
            altText: "Img",
            src: "images/publications/image11.png",
            title: 'Interfacially Engineered Transition Metal Phosphide Heterostructure for Zinc–Air Battery-Driven Hydrogen Production Coupled with Benzyl Alcohol Oxidation',
            text: "Santanu Ghora, Ritika Saroha, Bikram Kr Ghorai, Swastika Banerjee, Sandip Kumar Kuila, C. Retna Raj",
            link: "https://doi.org/10.1002/adfm.202515788"
        },
        {
            id: 2,
            altText: "Img",
            src: "images/publications/image0.png",
            title: 'Vacancy-Engineered Vanadium Cathode for Fast-Charging Aqueous Zinc Batteries of Ultra-Long Cycle Life',
            text: "Saheb Bag, Vikas Singh Thakur, Abhirup Bhadra, Swastika Banerjee, Dipan Kundu, C. Retna Raj",
            link: "https://doi.org/10.1002/adfm.202515788"
        },
        {
            id: 3,
            altText: "Img",
            src: "images/publications/image1.png",
            title: 'Shape-Controlled Synthesis of Nitrogen-Doped Carbon Encapsulated CoSn Intermetallic Electrocatalyst for Neutral and Alkaline Zinc–Air Batteries',
            text: "Santanu Ghora, C Retna Raj",
            link: "https://doi.org/10.1021/acsami.5c13658"
        },
        {
            id: 4,
            altText: "Img",
            src: "images/publications/image10.png",
            title: 'Paired Electrocatalysis: Nitrate Reduction to Ammonia Coupled with Anodic Upcycling of Biomass and Plastic Waste',
            text: "Loknath Thapa, Sudip Mallobarman, C Retna Raj",
            link: "https://doi.org/10.1021/acsami.5c13804"
        },
        {
            id: 5,
            altText: "Img",
            src: "images/publications/image2.png",
            title: 'Supercapacitors for energy storage: Fundamentals and materials design',
            text: "Sourav Mallick, Sourav Bag & C Retna Raj",
            link: "https://doi.org/10.1007/s12039-025-02394-7"
        },
        {
            id: 6,
            altText: "Img",
            src: "images/publications/image3.png",
            title: 'Cyano-Bridged Bimetallic Polymer Network-Derived Pd3Fe Intermetallic for Aqueous Rechargeable Zinc-Air Batteries',
            text: "Santanu Ghora, Biswarup Satpati, Bikash Kumar Jena & C Retna Raj",
            link: "https://doi.org/10.1021/acsami.4c19095"
        },
        {
            id: 7,
            altText: "Img",
            src: "images/publications/image4.png",
            title: 'Transition metal phosphide-based oxygen electrocatalysts for aqueous zinc–air batteries',
            text: "Santanu Ghora, Rishika Chakraborty, Saheb Bag, Mopidevi Manikanta Kumar & C Retna Raj",
            link: "https://doi.org/10.1039/d4cc05498a"
        },
        {
            id: 8,
            altText: "Img",
            src: "images/publications/image5.png",
            title: 'Electrochemical Engineering of Anode with Zincophilic Polymer Interface for Reversible Zinc Battery',
            text: "Akash Mukhraj Paswan ,Vikas Singh Thakur ,Swastika Banerjee & C. Retna Raj",
            link: "https://doi.org/10.1002/adfm.202412370"
        },
        {
            id: 9,
            altText: "Img",
            src: "images/publications/image6.png",
            text: "Mopidevi Manikanta Kumar ,Rahul Singh & C. Retna Raj",
            title: 'Surface-Engineered Ni2P: An Efficient Oxygen Electrocatalyst for Zinc-Air Battery',
            link: "https://doi.org/10.1002/asia.202400684"
        },
        {
            id: 10,
            altText: "Img",
            src: "images/publications/image7.png",
            text: "L Thapa & C Retna Raj",
            title: 'Tetrafunctional Electrocatalysts: Advantages and Limitations',
            link: "https://doi.org/10.1039/9781837674497-00489"
        },
    ]
}

const otherPublications = [
    {
        "156": "Santanu Ghora, Ritika Saroha, Bikram Kr Ghorai, Swastika Banerjee, Sandip Kumar Kuila, C. Retna Raj. Interfacially Engineered Transition Metal Phosphide Heterostructure for Zinc–Air Battery-Driven Hydrogen Production Coupled with Benzyl Alcohol Oxidation. Chemistry of Materials 38 (18):,9311–9322.."
    },
    {
        "155": "Saheb Bag, Vikas Singh Thakur, Abhirup Bhadra, Swastika Banerjee, Dipan Kundu, C. Retna Raj. Vacancy-Engineered Vanadium Cathode for Fast-Charging Aqueous Zinc Batteries of Ultra-Long Cycle Life.Advanced Functional Materials 2025. Advanced Functional Materials 36 (23), e15788"
    },
    {
        "154": "Santanu Ghora, C Retna Raj. Shape-Controlled Synthesis of Nitrogen-Doped Carbon Encapsulated CoSn Intermetallic Electrocatalyst for Neutral and Alkaline Zinc–Air Batteries.ACS Applied Materials & Interfaces 17 (44), 60490-60501"
    },
    {
        "153": "L Thapa, S Mallobarman,  C Retna Raj.Paired Electrocatalysis: Nitrate Reduction to Ammonia Coupled with Anodic Upcycling of Biomass and Plastic Waste.ACS Applied Materials & Interfaces 17 (42), 57803-57838"
    },
    {
        "152": "M Dutta, S Ghora, A Sahaw, CR Raj, M Bhattacharjee.A Low Molecular Weight Iron Metallogel as an OER Catalyst.Langmuir 41 (29), 19606-19613"
    },
    {
        "151": "Dahal, H.; Paswan, A. M.; Dey, J.; Raj, C. R. Harnessing the Potential of Amide-Linked Gemini Surfactants for Corrosion Inhibition and Antimicrobial Activity: From Molecular Design to Functional Performance.  Langmuir    2025  ,  41  (8), 5455–5466."
    },
    {
        "150": "Mallick, S.; Bag, S.; Raj, C. R. Supercapacitors for energy storage: Fundamentals and materials design. J. Chem. Sci. 137, 65, 2025."
    },
    {
        "149": "Ghora, S.; Satpati, B.; Jena, B. K.; Raj, C. R. Cyano-Bridged Bimetallic Polymer Network-Derived Pd₃Fe Intermetallic for Aqueous Rechargeable Zinc-Air Batteries.  ACS Appl. Mater. Interfaces 2025."
    },
    {
        "148": "Ghora, S.; Chakraborty, R.; Bag, S.; Kumar, M. M.; Raj, C. R. Transition Metal Phosphide-Based Oxygen Electrocatalysts for Aqueous Zinc–Air Batteries.  Chem. Commun. 2025."
    },
    {
        "147": "Ahmed, A. A. A.; Havenridge, S.; Sahoo, K.; Thapa, L.; Baksi, A.; Clever, G. H.; Raj, C. R. Effect of Ni‐Doping on the Optical, Structural, and Electrochemical Properties of Ag₂₉ Nanoclusters.  Small    2025  ,  21  (2), 2408096."
    },
    {
        "146": "Paswan, A. M.; Thakur, V. S.; Banerjee, S.; Raj, C. R. Electrochemical Engineering of Anode with Zincophilic Polymer Interface for Reversible Zinc Battery.  Adv. Funct. Mater.    2025  ,  35  (2), 2412370."
    },
    {
        "145": "Kumar, M. M.; Singh, R.; Raj, C. R. Surface‐Engineered Ni₂P: An Efficient Oxygen Electrocatalyst for Zinc‐Air Battery.  Chem.–Asian J.    2024  ,  19  (23), e202400684."
    },
    {
        "144": "Thapa, L.; Raj, C. R. Tetrafunctional Electrocatalysts: Advantages and Limitations.   2024  ."
    },
    {
        "143": "Samanta, A.; Kumar, M. M.; Ghora, S.; Ghatak, A.; Bhattacharya, S.; Kumar, V.; Raj, C. R. Tuning the Oxygen Electrocatalytic Performance of Metal-Doped Graphitic Carbon Nitride for the Development of Zinc-Air Battery.  J. Chem. Sci.    2024  ,  136  (3), 61."
    },
    {
        "142": "Kumar, M. M.; Aparna, C.; Nayak, A. K.; Waghmare, U. V.; Pradhan, D.; Raj, C. R. Surface Tailoring-Modulated Bifunctional Oxygen Electrocatalysis with CoP for Rechargeable Zn–Air Battery and Water Splitting.  ACS Appl. Mater. Interfaces    2024  ,  16  (3), 3542–3551."
    },
    {
        "141": "Bag, S.; Choutipalli, V. S. K.; Bhadra, A.; Shuford, K. L.; Kundu, D.; Raj, C. R. Carbothermal Reduction-Induced Oxygen Vacancies in Spinel Cathodes for High-Performance Aqueous Zinc-Ion Batteries.  J. Mater. Chem. A    2024  ,  12  (34), 22998–23007."
    },
    {
        "140": "Thapa, L.; Raj, C. R. Nitrogen Electrocatalysis: Electrolyte Engineering Strategies to Boost Faradaic Efficiency.  ChemSusChem    2023  ,  16  (20), e202300465."
    },
    {
        "139": "Satpathy, B. K.; Nayak, A. K.; Raj, C. R.; Pradhan, D. Morphology and Phase-Controlled Synthesis of Defect-Rich Layered Cobalt Hydroxide Nanostructures for the Oxygen Evolution Reaction.  ACS Appl. Eng. Mater.    2023  ,  1  (10), 2698–2706."
    },
    {
        "138": "Thapa, L.; Bhaumik, A.; Mondal, S.; Raj, C. R. A Heterostructured Electrocatalyst for the Electrochemical Valorization of 5-Hydroxymethylfurfural Coupled with the Hydrogen Evolution Reaction.  J. Mater. Chem. A    2023  ,  11  (47), 26242–26251."
    },
    {
        "137": "Satpathy, B. K.; Raj, C. R.; Pradhan, D. Facile Room Temperature Synthesis of CoSn(OH)₆/g-C₃N₄ Nanocomposite for Oxygen Evolution Reaction.  Electrochim. Acta    2022  ,  433 , 141250."
    },
    {
        "136": "Mallick, S.; Choutipalli, V. S. K.; Bag, S.; Subramanian, V.; Raj, C. R. Defect Engineered Ternary Spinel: An Efficient Cathode for an Aqueous Rechargeable Zinc-Ion Battery of Long-Term Cyclability.  ACS Appl. Mater. Interfaces    2022  ,  14  (33), 37577–37586."
    },
    {
        "135": "Ghosh, D.; Kumar, M. M.; Raj, C. R.; Pradhan, D. Bifunctional Catalytic Activity of Solvothermally Synthesized CeO₂ Nanosphere/NiO Nanoflake Nanocomposites.  ACS Appl. Energy Mater.    2022  ,  5  (5), 5666–5679."
    },
    {
        "134": "Mahato, J.; Raj, C. R.; Biswas, K. Low-Noise Potentiostat Circuit for Electrochemical Detection of Heavy Metals or Metalloids.  IEEE Trans. Instrum. Meas.    2022  ,  71 , 1–9."
    },
    {
        "133": "Kumar, M. M.; Raj, C. R. Heteroatom-Doped Carbon-Encapsulated FeP Nanostructure: A Multifunctional Electrocatalyst for Zinc–Air Battery and Water Electrolyzer.  ACS Appl. Mater. Interfaces    2022  ,  14  (13), 15176–15186."
    },
    {
        "132": "Pradhan, D.; Satpathy, B. K.; Raj, C. R. Facile Room Temperature Synthesis of CoSn(OH)₆/g-C₃N₄ Nanocomposite for Oxygen Evolution Reaction.  SSRN    2022  , 4147461."
    },
    {
        "131": "Bhadra, A.; Kundu, A.; Raj, C. R. Surface-Engineered Mesoporous Carbon-Based Material for the Electrochemical Detection of Hexavalent Chromium.  J. Chem. Sci.    2021  ,  133 , 1–7."
    },
    {
        "130": "Mondal, S.; Kumar, M. M.; Raj, C. R. Electrochemically Dealloyed Cu–Pt Nanostructures for Oxygen Reduction and Formic Acid Oxidation.  ACS Appl. Nano Mater.    2021  ,  4  (12), 13149–13157."
    },
    {
        "129": "Kundu, A.; Mallick, S.; Ghora, S.; Raj, C. R. Advanced Oxygen Electrocatalyst for Air-Breathing Electrode in Zn-Air Batteries.  ACS Appl. Mater. Interfaces    2021  ,  13  (34), 40172–40199."
    },
    {
        "128": "Kundu, A.; Samanta, A.; Raj, C. R. Hierarchical Hollow MOF-Derived Bamboo-like N-doped Carbon Nanotube-Encapsulated Co₀.₂₅Ni₀.₇₅ Alloy: An Efficient Bifunctional Oxygen Electrocatalyst for Zinc–Air Battery.  ACS Appl. Mater. Interfaces    2021  ,  13  (26), 30486–30496."
    },
    {
        "127": "Mallick, S.; Raj, C. R. Aqueous Rechargeable Zn‐Ion Batteries: Strategies for Improving the Energy Storage Performance.  ChemSusChem    2021  ,  14  (9), 1987–2022."
    },
    {
        "126": "Mallick, S.; Mondal, A.; Raj, C. R. Rationally Designed Mesoporous Carbon-Supported Ni–NiWO₄@NiS Nanostructure for the Fabrication of Hybrid Supercapacitor of Long-Term Cycling Stability.  J. Power Sources    2020  ,  477 , 229038."
    },
    {
        "125": "Chakrabartty, S.; Karmakar, S.; Raj, C. R. An Electrocatalytically Active Nanoflake-Like Co₉S₈-CoSe₂ Heterostructure for Overall Water Splitting.  ACS Appl. Nano Mater.    2020  ,  3  (11), 11326–11334."
    },
    {
        "124": "Samanta, A.; Barman, B. K.; Mallick, S.; Raj, C. R. Three-Dimensional Nitrogen-Doped Graphitic Carbon-Encapsulated MnO-Co Heterostructure: A Bifunctional Energy Storage Material for Zn-Ion and Zn–Air Batteries.  ACS Appl. Energy Mater.    2020  ,  3  (10), 10108–10118."
    },
    {
        "123": "Samanta, A.; Ghatak, A.; Bhattacharyya, S.; Raj, C. R. Transition Metal Alloy Integrated Tubular Carbon Hybrid Nanostructure for Bifunctional Oxygen Electrocatalysis.  Electrochim. Acta    2020  ,  348 , 136274."
    },
    {
        "122": "Samanta, A.; Raj, C. R. Oxygen Electrocatalysis with Mesoporous Co−N−C Catalysts: Towards Understanding the Active Site and Development of Rechargeable Zn‐Air Batteries.  ChemElectroChem    2020  ,  7  (13), 2877–2887."
    },
    {
        "121": "Samanta, A.; Raj, C. R. Bifunctional Nitrogen-Doped Hybrid Catalyst Based on Onion-Like Carbon and Graphitic Carbon Encapsulated Transition Metal Alloy Nanostructure for Rechargeable Zinc-Air Battery.  J. Power Sources    2020  ,  455 , 227975."
    },
    {
        "120": "Mondal, S.; Choutipalli, V. S. K.; Jena, B. K.; Subramanian, V.; Raj, C. R. Bifunctional Electrocatalytic Activity of Ordered Intermetallics Based on Pd and Sn.  J. Phys. Chem. C    2020  ,  124  (18), 9631–9643."
    },
    {
        "119": "Chakrabartty, S.; Sahu, D.; Raj, C. R. General Approach for the Synthesis of Nitrogen-Doped Carbon Encapsulated Mo and W Phosphide Nanostructures for Electrocatalytic Hydrogen Evolution.  ACS Appl. Energy Mater.    2020  ,  3  (3), 2811–2820."
    },
    {
        "118": "Mallick, S.; Samanta, A.; Raj, C. R. Mesoporous Carbon-Supported Manganese Tungstate Nanostructures for the Development of Zinc–Air Battery Powered Long Lifespan Asymmetric Supercapacitor.  Sustainable Energy Fuels    2020  ,  4  (8), 4008–4017."
    },
    {
        "117": "Karan, C. K.; Mallick, S.; Raj, C. R.; Bhattacharjee, M. A Self‐Healing Metal–Organic Hydrogel for an All‐Solid Flexible Supercapacitor.  Chem.–Eur. J.    2019  ,  25  (65), 14775–14779."
    },
    {
        "116": "Samanta, A.; Raj, C. R. A New Approach for the Synthesis of Electrocatalytically Active CoFe₂O₄ Catalyst for Oxygen Reduction Reaction.  J. Electroanal. Chem.    2019  ,  847 , 113183."
    },
    {
        "115": "Mondal, S.; Raj, C. R. Electrochemical Dealloying-Assisted Surface-Engineered Pd-Based Bifunctional Electrocatalyst for Formic Acid Oxidation and Oxygen Reduction.  ACS Appl. Mater. Interfaces    2019  ,  11  (15), 14110–14119."
    },
    {
        "114": "Kumar, M. M.; Raj, C. R. Carbothermal-Reduction-Assisted Phosphidation of Cobalt Affords Mesoporous Nitrogen-Doped Carbon-Embedded CoP Nanoelectrocatalysts for the Oxygen Reduction Reaction.  ACS Appl. Nano Mater.    2019  ,  2  (2), 643–648."
    },
    {
        "113": "Barman, B. K.; Raj, C. R. Nitrogen and Phosphorous Co-Doped Graphitic Carbon Encapsulated Ultrafine OsP₂ Nanoparticles: A pH Universal Highly Durable Catalyst for Hydrogen Evolution Reaction.   2019  ."
    },
    {
        "112": "Satpathy, B. K.; Nayak, A. K.; Raj, C. R.; Pradhan, D. Morphology-Dependent Charge Storage Performance of Co₃O₄ Nanostructures in an All-Solid-State Flexible Supercapacitor.  New J. Chem.    2019  ,  43  (38), 15177–15186."
    },
    {
        "111": "Chakrabartty, S.; Barman, B. K.; Raj, C. R. Nitrogen and Phosphorous Co-Doped Graphitic Carbon Encapsulated Ultrafine OsP₂ Nanoparticles: A pH Universal Highly Durable Catalyst for Hydrogen Evolution Reaction.  Chem. Commun.    2019  ,  55  (30), 4399–4402."
    },
    {
        "110": "Chakrabartty, S.; Raj, C. R. Mo₂C@NC Nanowire Bundle for Efficient Electrocatalytic Hydrogen Evolution.  Int. J. Hydrogen Energy    2018  ,  43  (42), 19510–19520."
    },
    {
        "109": "Mallick, S.; Jana, P. P.; Raj, C. R. Asymmetric Supercapacitor Based on Chemically Coupled Hybrid Material of Fe₂O₃‐Fe₃O₄ Heterostructure and Nitrogen‐Doped Reduced Graphene Oxide.  ChemElectroChem    2018  ,  5  (17), 2348–2356."
    },
    {
        "108": "Mondal, S.; Raj, C. R. Copper Nitride Nanostructure for the Electrocatalytic Reduction of Oxygen: Kinetics and Reaction Pathway.  J. Phys. Chem. C    2018  ,  122  (32), 18468–18475."
    },
    {
        "107": "Samanta, A.; Raj, C. R. Catalyst Support in Oxygen Electrocatalysis: A Case Study with CoFe Alloy Electrocatalyst.  J. Phys. Chem. C    2018  ,  122  (28), 15843–15852."
    },
    {
        "106": "Manna, B.; Raj, C. R. Nanostructured Sulfur-Doped Porous Reduced Graphene Oxide for the Ultrasensitive Electrochemical Detection and Efficient Removal of Hg(II).  ACS Sustainable Chem. Eng.    2018  ,  6  (5), 6175–6182."
    },
    {
        "105": "Mondal, S.; Ghosh, S.; Raj, C. R. Unzipping of Single-Walled Carbon Nanotube for the Development of Electrocatalytically Active Hybrid Catalyst of Graphitic Carbon and Pd Nanoparticles.  ACS Omega    2018  ,  3  (1), 622–630."
    },
    {
        "104": "Manna, B.; Raj, C. R. Inorganic–Organic Hybrid 3D Redox Nanoarchitecture for the Electrocatalytic Sensing of Thiols.  ACS Sustainable Chem. Eng.    2017  ,  5  (10), 9412–9422."
    },
    {
        "103": "Chakrabartty, S.; Gopinath, C. S.; Raj, C. R. Polymer-Based Hybrid Catalyst of Low Pt Content for Electrochemical Hydrogen Evolution.  Int. J. Hydrogen Energy    2017  ,  42  (36), 22821–22829."
    },
    {
        "102": "Samanta, A.; Raj, C. R. Oxygen Electrocatalyst Based on Non-Precious Bifunctional Hybrid Material.  Electrochem. Soc. Meet. Abstr.    2017  ,  231 , 582."
    },
    {
        "101": "Mondal, S.; Raj, C. R. Copper Nitride-Based Electrocatalyst for Oxygen Reduction Reaction.  Electrochem. Soc. Meet. Abstr.    2017  ,  231 , 868."
    },
    {
        "100": "Chakrabartty, S.; Raj, C. R. A Hybrid Material Based on Molybdenum Carbide and Nitrogen Doped Carbon for Electrochemical Hydrogen Evolution.  Electrochem. Soc. Meet. Abstr.    2017  ,  231 , 1396."
    },
    {
        "99": "Bag, S.; Samanta, A.; Bhunia, P.; Raj, C. R. Corrigendum to “Rational Functionalization of Reduced Graphene Oxide with Imidazolium-Based Ionic Liquid for Supercapacitor Application”.  Int. J. Hydrogen Energy    2017  ,  42  (5), 3420."
    },
    {
        "98": "Bag, S.; Samanta, A.; Bhunia, P.; Raj, C. R. Rational Functionalization of Reduced Graphene Oxide with Imidazolium-Based Ionic Liquid for Supercapacitor Application.  Int. J. Hydrogen Energy    2016  ,  41  (47), 22134–22143."
    },
    {
        "97": "Bag, S.; Raj, C. R. On the Electrocatalytic Activity of Nitrogen-Doped Reduced Graphene Oxide: Does the Nature of Nitrogen Really Control the Activity Towards Oxygen Reduction?  J. Chem. Sci.    2016  ,  128 , 339–347."
    },
    {
        "96": "Raj, C. R.; Samanta, A.; Noh, S. H.; Mondal, S.; Okajima, T.; Ohsaka, T. Emerging New Generation Electrocatalysts for the Oxygen Reduction Reaction.  J. Mater. Chem. A    2016  ,  4  (29), 11156–11178."
    },
    {
        "95": "Manna, B.; Raj, C. R. Covalent Functionalization and Electrochemical Tuning of Reduced Graphene Oxide for the Bioelectrocatalytic Sensing of Serum Lactate.  J. Mater. Chem. B    2016  ,  4  (26), 4585–4593."
    },
    {
        "94": "Bag, S.; Raj, C. R. Facile Shape-Controlled Growth of Hierarchical Mesoporous δ-MnO₂ for the Development of Asymmetric Supercapacitors.  J. Mater. Chem. A    2016  ,  4  (21), 8384–8394."
    },
    {
        "93": "Bag, S.; Raj, C. R. Hierarchical Three-Dimensional Mesoporous MnO₂ Nanostructures for High Performance Aqueous Asymmetric Supercapacitors.  J. Mater. Chem. A    2016  ,  4  (2), 587–595."
    },
    {
        "92": "Bera, R. K.; Bhunia, P.; Chakrabartty, S.; Raj, C. R. Inside Back Cover: Visible‐Light‐Driven Production of Poly(α‐terthiophene)–Au Nanoparticle Functional Hybrid Material.  ChemNanoMat    2015  ,  1  (8), 615."
    },
    {
        "91": "Bera, R. K.; Bhaumik, A.; Raj, C. R. Facile Growth of Multi-Twined Au Nanostructures.  J. Chem. Sci.    2015  ,  127 , 2111–2118."
    },
    {
        "90": "Bera, R. K.; Bhunia, P.; Chakrabartty, S.; Raj, C. R. Visible‐Light‐Driven Production of Poly(α‐terthiophene)–Au Nanoparticle Functional Hybrid Material.  ChemNanoMat    2015  ,  1  (8), 586–592."
    },
    {
        "89": "Das, A. K.; Raj, C. R. Electrochemical Decoration of Carbon Nanotubes with Au Nanostructure for the Electroanalysis of Biomolecules.  Anal. Sci.    2015  ,  31  (7), 711–714."
    },
    {
        "88": "Datta, D.; Bera, R. K.; Jana, S.; Manna, B.; Roy, D.; Anoop, A.; Raj, C. R.; Pathak, T. A Rationally Designed Thymidine‐Based Self‐Assembled Monolayer on a Gold Electrode for Electroanalytical Applications.  Chem.–Asian J.    2015  ,  10  (7), 1554–1560."
    },
    {
        "87": "Ghosh, S.; Raj, C. R. Pt-Pd Nanoelectrocatalyst of Ultralow Pt Content for the Oxidation of Formic Acid: Towards Tuning the Reaction Pathway.  J. Chem. Sci.    2015  ,  127 , 949–957."
    },
    {
        "86": "Bag, S.; Mondal, B.; Das, A. K.; Raj, C. R. Nitrogen and Sulfur Dual-Doped Reduced Graphene Oxide: Synergistic Effect of Dopants Towards Oxygen Reduction Reaction.  Electrochim. Acta    2015  ,  163 , 16–23."
    },
    {
        "85": "Bag, S.; Raj, C. R. Reduced Graphene Oxide Based Layer-By-Layer Inorganic-Organic Hybrid Material for Asymmetric Supercapacitor Device.  Electrochem. Soc. Meet. Abstr.    2015  ,  227 , 223."
    },
    {
        "84": "Bag, S.; Raj, C. R. Hierarchical Three-Dimensional Mesoporous MnO₂ Nanostructures for High Performance Aqueous Asymmetric Supercapacitors.   2015  ."
    },
    {
        "83": "Dey, R. S.; Raj, C. R. Enzyme-Integrated Cholesterol Biosensing Scaffold Based on In Situ Synthesized Reduced Graphene Oxide and Dendritic Pd Nanostructure.  Biosens. Bioelectron.    2014  ,  62 , 357–364."
    },
    {
        "82": "Bera, R. K.; Mandal, S. M.; Raj, C. R. Antimicrobial Activity of Fluorescent Ag Nanoparticles.  Lett. Appl. Microbiol.    2014  ,  58  (6), 520–526."
    },
    {
        "81": "Das, A. K.; Raj, C. R. Shape-Controlled Growth of Surface-Confined Au Nanostructures for Electroanalytical Applications.  J. Electroanal. Chem.    2014  ,  717 , 140–146."
    },
    {
        "80": "Bag, S.; Roy, K.; Gopinath, C. S.; Raj, C. R. Facile Single-Step Synthesis of Nitrogen-Doped Reduced Graphene Oxide-Mn₃O₄ Hybrid Functional Material for the Electrocatalytic Reduction of Oxygen.  ACS Appl. Mater. Interfaces    2014  ,  6  (4), 2692–2699."
    },
    {
        "79": "Bag, S.; Raj, C. R. Layered Inorganic–Organic Hybrid Material Based on Reduced Graphene Oxide and α-Ni(OH)₂ for High Performance Supercapacitor Electrodes.  J. Mater. Chem. A    2014  ,  2  (42), 17848–17856."
    },
    {
        "78": "Ghosh, S.; Mondal, S.; Raj, C. R. Carbon Nanotube-Supported Dendritic Pt-on-Pd Nanostructures: Growth Mechanism and Electrocatalytic Activity Towards Oxygen Reduction Reaction.  J. Mater. Chem. A    2014  ,  2  (7), 2233–2239."
    },
    {
        "77": "Raj, C. R.; Jena, B. K. Ultra-Sensitive Simultaneous Electrochemical Determination of Arsenic, Mercury and Copper. US Patent 8,568,825,   2013  ."
    },
    {
        "76": "Bera, R. K.; Raj, C. R. A Facile Photochemical Route for the Synthesis of Triangular Ag Nanoplates and Colorimetric Sensing of H₂O₂.  J. Photochem. Photobiol. A Chem.    2013  ,  270 , 1–6."
    },
    {
        "75": "Das, A. K.; Raj, C. R. Shape and Surface Structure-Dependent Electrocatalytic Activity of Au Nanoparticles.  Electrochim. Acta    2013  ,  107 , 592–598."
    },
    {
        "74": "Dey, R. S.; Raj, C. R. Redox-Functionalized Graphene Oxide Architecture for the Development of Amperometric Biosensing Platform.  ACS Appl. Mater. Interfaces    2013  ,  5  (11), 4791–4798."
    },
    {
        "73": "Dey, R. S.; Bera, R. K.; Raj, C. R. Nanomaterial-Based Functional Scaffolds for Amperometric Sensing of Bioanalytes.  Anal. Bioanal. Chem.    2013  ,  405 , 3431–3448."
    },
    {
        "72": "Behera, S.; Dey, R. S.; Rana, M. K.; Raj, C. R. Electrochemistry of Surface Wired Cytochrome c and Bioelectrocatalytic Sensing of Superoxide.  J. Chem. Sci.    2013  ,  125 , 275–282."
    },
    {
        "71": "Dey, R. S.; Raj, C. R. A Hybrid Functional Nanoscaffold Based on Reduced Graphene Oxide–ZnO for the Development of an Amperometric Biosensing Platform.  RSC Adv.    2013  ,  3  (48), 25858–25864."
    },
    {
        "70": "Ghosh, S.; Raj, C. R. Shape-Controlled Synthesis of Pt Nanostructures and Evaluation of Catalytic and Electrocatalytic Performance.  Catal. Sci. Technol.    2013  ,  3  (4), 1078–1085."
    },
    {
        "69": "Ghosh, S.; Sahu, R. K.; Raj, C. R. Pt–Pd Alloy Nanoparticle-Decorated Carbon Nanotubes: A Durable and Methanol Tolerant Oxygen Reduction Electrocatalyst.  Nanotechnology    2012  ,  23  (38), 385602."
    },
    {
        "68": "Ghosh, S.; Raj, C. R. Pt-Pd Bimetallic Alloy Nanoelectrocatalyst for Oxygen Reduction Reaction: Study of the Effect of Composition on Electrocatalysis.  ECS Meet. Abstr.    2012  , 577."
    },
    {
        "67": "Dey, R. S.; Raj, C. R. Polyelectrolyte-Functionalized Gold Nanoparticle Scaffold for the Sensing of Heparin and Protamine in Serum.  Chem.–Asian J.    2012  ,  7  (2), 417–424."
    },
    {
        "66": "Dey, R. S.; Gupta, S.; Paira, R.; Chen, S. M.; Raj, C. R. Flow Injection Amperometric Sensing of Uric Acid and Ascorbic Acid Using the Self-Assembly of Heterocyclic Thiol on Au Electrode.  J. Solid State Electrochem.    2012  ,  16 , 173–178."
    },
    {
        "65": "Dey, R. S.; Hajra, S.; Sahu, R. K.; Raj, C. R.; Panigrahi, M. K. A Rapid Room Temperature Chemical Route for the Synthesis of Graphene: Metal-Mediated Reduction of Graphene Oxide.  Chem. Commun.    2012  ,  48  (12), 1787–1789."
    },
    {
        "64": "Das, A. K.; Raj, C. R. Iodide-Mediated Reduction of AuCl₄⁻ and a New Green Route for the Synthesis of Single Crystalline Au Nanostructures with Pronounced Electrocatalytic Activity.  J. Phys. Chem. C    2011  ,  115  (43), 21041–21046."
    },
    {
        "63": "Jena, B. K.; Raj, C. R. Enzyme Integrated Silicate–Pt Nanoparticle Architecture: A Versatile Biosensing Platform.  Biosens. Bioelectron.    2011  ,  26  (6), 2960–2966."
    },
    {
        "62": "Das, A. K.; Raj, C. R. Rapid Room Temperature Synthesis of Electrocatalytically Active Au Nanostructures.  J. Colloid Interface Sci.    2011  ,  353  (2), 506–511."
    },
    {
        "61": "Bera, R. K.; Anoop, A.; Raj, C. R. Enzyme-Free Colorimetric Assay of Serum Uric Acid.  Chem. Commun.    2011  ,  47  (41), 11498–11500."
    },
    {
        "60": "Ghosh, S.; Sahu, R. K.; Raj, C. R. Shape-Regulated High Yield Synthesis of Electrocatalytically Active Branched Pt Nanostructures for Oxygen Reduction and Methanol Oxidation Reactions.  J. Mater. Chem.    2011  ,  21  (32), 11973–11980."
    },
    {
        "59": "Bera, R. K.; Raj, C. R. Naked Eye Sensing of Melamine Using Rationally Tailored Gold Nanoparticles: Hydrogen-Bonding and Charge-Transfer Recognition.  Analyst    2011  ,  136  (8), 1644–1648."
    },
    {
        "58": "Dey, R. S.; Raj, C. R. Development of an Amperometric Cholesterol Biosensor Based on Graphene−Pt Nanoparticle Hybrid Material.  J. Phys. Chem. C    2010  ,  114  (49), 21427–21433."
    },
    {
        "57": "Chakraborty, S.; Raj, C. R. Electrocatalytic Performance of Carbon Nanotube-Supported Palladium Particles in the Oxidation of Formic Acid and the Reduction of Oxygen.  Carbon    2010  ,  48  (11), 3242–3249."
    },
    {
        "56": "Bera, R. K.; Das, A. K.; Raj, C. R. Enzyme-Cofactor-Assisted Photochemical Synthesis of Ag Nanostructures and Shape-Dependent Optical Sensing of Hg(II) Ions.  Chem. Mater.    2010  ,  22  (15), 4505–4511."
    },
    {
        "55": "Ghosh, S.; Raj, C. R. Facile In Situ Synthesis of Multiwall Carbon Nanotube Supported Flowerlike Pt Nanostructures: An Efficient Electrocatalyst for Fuel Cell Application.  J. Phys. Chem. C    2010  ,  114  (24), 10843–10849."
    },
    {
        "54": "Dey, R. S.; Gupta, S.; Paira, R.; Raj, C. R. Electrochemically Derived Redox Molecular Architecture: A Novel Electrochemical Interface for Voltammetric Sensing.  ACS Appl. Mater. Interfaces    2010  ,  2  (5), 1355–1360."
    },
    {
        "53": "Chakraborty, S.; Raj, C. R. Carbon Nanotube Supported Platinum Nanoparticles for the Voltammetric Sensing of Hydrazine.  Sens. Actuators B Chem.    2010  ,  147  (1), 222–227."
    },
    {
        "52": "Jena, B. K.; Raj, C. R. Au Nanoparticle Decorated Silicate Network for the Amperometric Sensing of Isoniazid.  Talanta    2010  ,  80  (5), 1653–1656."
    },
    {
        "51": "Das, A. K.; Raj, C. R. Facile Growth of Flower-Like Au Nanocrystals and Electroanalysis of Biomolecules.  J. Electroanal. Chem.    2010  ,  638  (2), 189–194."
    },
    {
        "50": "Jena, B. K.; Ghosh, S.; Bera, R.; Dey, R. S.; Das, A. K.; Raj, C. R. Bioanalytical Applications of Au Nanoparticles.  Recent Pat. Nanotechnol.    2010  ,  4  (1), 41–52."
    },
    {
        "49": "Chakraborty, S.; Raj, C. R. Pt Nanoparticle-Based Highly Sensitive Platform for the Enzyme-Free Amperometric Sensing of H₂O₂.  Biosens. Bioelectron.    2009  ,  24  (11), 3264–3268."
    },
    {
        "48": "Raj, C. R.; Das, A. K. Au Nanoparticle Based Biosensing Platform.  ECS Meet. Abstr.    2008  , 2839."
    },
    {
        "47": "Behera, S.; Raj, C. R. Electrochemistry of Surface Wired Redox Protein: Axial Ligation and Control of Redox Potential.  J. Electroanal. Chem.    2008  ,  619 , 159–163."
    },
    {
        "46": "Jena, B. K.; Raj, C. R. Highly Sensitive and Selective Electrochemical Detection of Sub-ppb Level Chromium (VI) Using Nano-Sized Gold Particle.  Talanta    2008  ,  76  (1), 161–165."
    },
    {
        "45": "Jena, B. K.; Raj, C. R. Seedless, Surfactantless Room Temperature Synthesis of Single Crystalline Fluorescent Gold Nanoflowers with Pronounced SERS and Electrocatalytic Activity.  Chem. Mater.    2008  ,  20  (11), 3546–3548."
    },
    {
        "44": "Jena, B. K.; Raj, C. R. Morphology Dependent Electrocatalytic Activity of Au Nanoparticles.  Electrochem. Commun.    2008  ,  10  (6), 951–954."
    },
    {
        "43": "Jena, B. K.; Raj, C. R. Optical Sensing of Biomedically Important Polyionic Drugs Using Nano-Sized Gold Particles.  Biosens. Bioelectron.    2008  ,  23  (8), 1285–1290."
    },
    {
        "42": "Jena, B. K.; Raj, C. R. Electrocatalytic Applications of Nanosized Pt Particles Self-Assembled on Sol−Gel-Derived Three-Dimensional Silicate Network.  J. Phys. Chem. C    2008  ,  112  (10), 3496–3502."
    },
    {
        "41": "Behera, S.; Sampath, S.; Raj, C. R. Electrochemical Functionalization of a Gold Electrode with Redox-Active Self-Assembled Monolayer for Electroanalytical Application.  J. Phys. Chem. C    2008  ,  112  (10), 3734–3740."
    },
    {
        "40": "Behera, S.; Raj, C. R. Self-Assembled Monolayers of Thio-Substituted Nucleobases on Gold Electrode for the Electroanalysis of NADH, Ethanol and Uric Acid.  Sens. Actuators B Chem.    2007  ,  128  (1), 31–38."
    },
    {
        "39": "Chandra, D.; Jena, B. K.; Raj, C. R.; Bhaumik, A. Functionalized Mesoporous Cross-Linked Polymer as Efficient Host for Loading Gold Nanoparticles and Its Electrocatalytic Behavior for Reduction of H₂O₂.  Chem. Mater.    2007  ,  19  (25), 6290–6296."
    },
    {
        "38": "Behera, S.; Raj, C. R. Mercaptoethylpyrazine Promoted Electrochemistry of Redox Protein and Amperometric Biosensing of Uric Acid.  Biosens. Bioelectron.    2007  ,  23  (4), 556–561."
    },
    {
        "37": "Chakraborty, S.; Raj, C. R. Mediated Electrocatalytic Oxidation of Bioanalytes and Biosensing of Glutamate Using Functionalized Multiwall Carbon Nanotubes-Biopolymer Nanocomposite.  J. Electroanal. Chem.    2007  ,  609  (2), 155–162."
    },
    {
        "36": "Jena, B. K.; Raj, C. R. Shape-Controlled Synthesis of Gold Nanoprism and Nanoperiwinkles with Pronounced Electrocatalytic Activity.  J. Phys. Chem. C    2007  ,  111  (42), 15146–15153."
    },
    {
        "35": "Chakraborty, S.; Raj, C. R. Amperometric Biosensing of Glutamate Using Carbon Nanotube Based Electrode.  Electrochem. Commun.    2007  ,  9  (6), 1323–1330."
    },
    {
        "34": "Jena, B. K.; Raj, C. R. Ultrasensitive Nanostructured Platform for the Electrochemical Sensing of Hydrazine.  J. Phys. Chem. C    2007  ,  111  (17), 6228–6232."
    },
    {
        "33": "Jena, B. K.; Raj, C. R. Amperometric L‐Lactate Biosensor Based on Gold Nanoparticles.  Electroanalysis    2007  ,  19  (14), 1478–1485."
    },
    {
        "32": "Jena, B. K.; Raj, C. R. Synthesis of Flower-Like Gold Nanoparticles and Their Electrocatalytic Activity Towards the Oxidation of Methanol and the Reduction of Oxygen.  Langmuir    2007  ,  23  (7), 4064–4070."
    },
    {
        "31": "Raj, C. R.; Behera, S. Electrochemically Triggered Michael Addition on the Self-Assembly of 4-Thiouracil: Generation of Surface-Confined Redox Mediator and Electrocatalysis.  Langmuir    2007  ,  23  (4), 1600–1607."
    },
    {
        "30": "Raj, C. R.; Chakraborty, S. Carbon Nanotubes–Polymer–Redox Mediator Hybrid Thin Film for Electrocatalytic Sensing.  Biosens. Bioelectron.    2006  ,  22  (5), 700–706."
    },
    {
        "29": "Jena, B. K.; Raj, C. R. Electrochemical Biosensor Based on Integrated Assembly of Dehydrogenase Enzymes and Gold Nanoparticles.  Anal. Chem.    2006  ,  78  (18), 6332–6339."
    },
    {
        "28": "Jena, B. K.; Raj, C. R. Enzyme‐Free Amperometric Sensing of Glucose by Using Gold Nanoparticles.  Chem.–Eur. J.    2006  ,  12  (10), 2702–2708."
    },
    {
        "27": "Raj, C. R.; Behera, S. Mediatorless Voltammetric Oxidation of NADH and Sensing of Ethanol.  Biosens. Bioelectron.    2005  ,  21  (6), 949–956."
    },
    {
        "26": "Raj, C. R.; Abdelrahman, A. I.; Ohsaka, T. Gold Nanoparticle-Assisted Electroreduction of Oxygen.  Electrochem. Commun.    2005  ,  7  (9), 888–893."
    },
    {
        "25": "Raj, C. R.; Behera, S. Electrochemical Studies of 6-Mercaptonicotinic Acid Monolayer on Au Electrode.  J. Electroanal. Chem.    2005  ,  581  (1), 61–69."
    },
    {
        "24": "Raj, C. R.; Jena, B. K. Efficient Electrocatalytic Oxidation of NADH at Gold Nanoparticles Self-Assembled on Three-Dimensional Sol-Gel Network.  Chem. Commun.    2005  , 67."
    },
    {
        "23": "Ohsaka, T.; Raj, C. R. Electrochemical Sensors Based on Self-Assembled Monolayers (SAMs) of Metallomacrocycles. In  Metal Complexes and Metals in Macromolecules: Synthesis, Structure and Properties ;   2003  ."
    },
    {
        "22": "Raj, C. R.; Okajima, T.; Ohsaka, T. Gold Nanoparticle Arrays for the Voltammetric Sensing of Dopamine.  J. Electroanal. Chem.    2003  ,  543  (2), 127–133."
    },
    {
        "21": "Raj, C. R.; Ohsaka, T. Voltammetric Detection of Uric Acid in the Presence of Ascorbic Acid at a Gold Electrode Modified with a Self-Assembled Monolayer of Heteroaromatic Thiol.  J. Electroanal. Chem.    2003  ,  540 , 69–77."
    },
    {
        "20": "Raj, C. R.; Ohsaka, T. Analytical Applications of Functionalized Self‐Assembled Monolayers on Gold Electrode: Voltammetric Sensing of DOPAC at the Physiological Level.  Electroanalysis    2002  ,  14  (13), 919–925."
    },
    {
        "19": "Raj, C. R.; Okajima, T.; Ohsaka, T. Voltammetric Measurement of pH Using a Mixed Self-Assembly of Macrocyclic Nickel (II) Complex and Diimine on Gold Electrode.  Electrochem. Commun.    2002  ,  4  (4), 330–335."
    },
    {
        "18": "Raj, C. R.; Kitamura, F.; Ohsaka, T. Square Wave Voltammetric Sensing of Uric Acid Using the Self-Assembly of Mercaptobenzimidazole.  Analyst    2002  ,  127  (9), 1155–1158."
    },
    {
        "17": "Raj, C. R.; Ramaraj, R. Emission of Thioflavin T and Its Off–On Control in Polymer Membranes.  Photochem. Photobiol.    2001  ,  74  (6), 752–759."
    },
    {
        "16": "Raj, C. R.; Kitamura, F.; Ohsaka, T. Electrochemical and In Situ FTIR Spectroscopic Investigation on the Electrochemical Transformation of 4-Aminothiophenol on a Gold Electrode in Neutral Solution.  Langmuir    2001  ,  17  (23), 7378–7386."
    },
    {
        "15": "Raj, C. R.; Ohsaka, T. Electrocatalytic Sensing of NADH at an In Situ Functionalized Self-Assembled Monolayer on Gold Electrode.  Electrochem. Commun.    2001  ,  3  (11), 633–638."
    },
    {
        "14": "Raj, C. R. The Fascinating Land of Japan.  Electrochemistry    2001  ,  69  (10), 812–812."
    },
    {
        "13": "Raj, C. R.; Ohsaka, T. Simultaneous Electroanalysis of Ascorbic Acid, Dihydroxyphenylacetic Acid, Homovanillic Acid and Uric Acid Using Gold Electrode Modified with Cationic Self-Assembled Monolayers.  Chem. Lett.    2001  ,  30  (7), 670–671."
    },
    {
        "12": "Ramaraj, R.; Kumar, V. M.; Raj, C. R.; Ganesane, V. β-Cyclodextrin Inclusion Complexes of Aromatic Amines and Nitrocompounds and Their Photoinduced Electron Transfer Reaction with the Tris(2,2'-bipyridine)ruthenium(II) Complex.  J. Incl. Phenom. Macrocycl. Chem.    2001  ,  40 , 99–104."
    },
    {
        "11": "Raj, C. R.; Ohsaka, T. Facilitated Electrochemical Oxidation of NADH and Its Model Compound at Gold Electrode Modified with Terminally Substituted Electroinactive Self-Assembled Monolayers.  Bioelectrochemistry    2001  ,  53  (2), 251–256."
    },
    {
        "10": "Raj, C. R.; Tokuda, K.; Ohsaka, T. Electroanalytical Applications of Cationic Self-Assembled Monolayers: Square-Wave Voltammetric Determination of Dopamine and Ascorbate.  Bioelectrochemistry    2001  ,  53  (2), 183–191."
    },
    {
        "9": "Raj, C. R.; Ohsaka, T. Electroanalysis of Ascorbate and Dopamine at a Gold Electrode Modified with a Positively Charged Self-Assembled Monolayer.  J. Electroanal. Chem.    2001  ,  496  (1–2), 44–49."
    },
    {
        "8": "Raj, C. R.; Gobi, K. V.; Ohsaka, T. Electrocatalytic Oxidation of NADH at the Self-Assembled Monolayer of Nickel (II) Macrocycle on Gold Electrode.  Bioelectrochemistry    2000  ,  51  (2), 181–186."
    },
    {
        "7": "Ilanchelian, M.; Raj, C. R.; Ramaraj, R. Spectral Studies on the Cyclodextrin Inclusion Complexes of Toluidine Blue O and Meldola's Blue in Aqueous Solution.  J. Incl. Phenom. Macrocycl. Chem.    2000  ,  36 , 9–20."
    },
    {
        "6": "Raj, C. R.; Ohsaka, T. Simultaneous Detection of Ascorbic Acid and Dopamine at Gold Electrode Modified with a Self-Assembled Monolayer of Cystamine.  Electrochemistry    1999  ,  67  (12), 1175–1177."
    },
    {
        "5": "Jena, B. K.; Raj, C. R. Electrochemical Study of the Cyclodextrin Encapsulation of a Macrocyclic Nickel Complex.  Electrochim. Acta    1999  ,  44  (16), 2685–2691."
    },
    {
        "4": "Raj, C. R.; Ramaraj, R. Influence of Cyclodextrin Complexation on the Emission of Thioflavin T and Its Off-On Control.  J. Photochem. Photobiol. A Chem.    1999  ,  122  (1), 39–46."
    },
    {
        "3": "Raj, C. R.; Ramaraj, R. Study of Surfactant–Cyclodextrin Complexation by Cyclic Voltammetry Using Polypyridyl Metal Complexes as Electroactive Probes.  Electrochim. Acta    1998  ,  44  (2–3), 279–285."
    },
    {
        "2": "Raj, C. R.; Ramaraj, R. γ-Cyclodextrin Induced Intermolecular Excimer Formation of Thioflavin T.  Chem. Phys. Lett.    1997  ,  273  (3–4), 285–290."
    },
    {
        "1": "Raj, C. R.; Ramaraj, R. Electrochemistry and Photoelectrochemistry of Phenothiazine Dye-β-Cyclodextrin Inclusion Complexes.  J. Electroanal. Chem.    1996  ,  405  (1–2), 141–147."
    }
];

const newsDetails = {
    heading: 'Currently @ FME Lab',
    details: [
        {
            text: 'Check our latest publication in Chemistry of Materials. https://doi.org/10.1021/acs.chemmater.6c01266 Congratulations to Santanu and his co-authors!',
        },
        {
            text: 'Our Alumni Dr. Sourav Mallick has joined IISER Berhampur as Assistant Professor. Congratulations Dr. Sourav!',
        },
        {
            text: 'Aritra has joined our lab as PhD student. Welcome to FME Lab!',
        },
        {
            text: "Sudhanshu has joined our lab as a Master's student. Welcome to FME Lab!",
        },
        {
            text: "Biswajit and Savitha have been awarded 'Look within' fellowship by IIT KGP for their Summer Internship. Deepthi has recieved Summer Research fellowship award from Indian Academy of Sciences. Congratulations all of you!",
        },
        {
            text: " Biswajit, Savitha, Deepthi, and Amritapunya has joined our lab as Summer interns. Welcome to FME Lab!",
        },
        {
            text: " Saheb has successfully defended his PhD thesis on 'Defect-Engineered Electrode Materials for High-Performance Aqueous Zinc-Based Energy Storage Devices' on 29th-sep-2025. Congratulations Dr. Saheb!",
        },
    ]
}

const materialsLibrary = {
    details: [
        {
            title: "Source:  Anal. Chem.2006, 78, 18, 6332-6339",
            src: "images/materials-library/pic1.jpg"
        },
        {
            title: "Source:  Anal. Chem.2008, 80, 13, 4836-4844",
            src: "images/materials-library/pic2.jpg"
        },
        {
            title: "Source:  Chem. Mater.2008, 20, 11, 3546-3548",
            src: "images/materials-library/pic3.jpg"
        },
        {
            title: "Source:  J. Phys. Chem. C 2008, 112, 10, 3496-3502",
            src: "images/materials-library/pic4.jpg"
        },
        {
            title: "Source: J. Phys. Chem. C 2010, 114, 49, 21427-21433",
            src: "images/materials-library/pic5.jpg"
        },
        {
            title: "Source: Chem. Mater. 2010, 22, 15, 4505-4511",
            src: "images/materials-library/pic6.jpg"
        },
        {
            title: "Source: J. Phys. Chem. C 2011, 115, 43, 21041-21046",
            src: "images/materials-library/pic7.jpg"
        },
        {
            title: "Source: J. Mater. Chem., 2011,21, 11973-11980",
            src: "images/materials-library/pic8.jpg"
        },
        {
            title: "Source: Chem. Commun., 2012, 48, 1787-1789",
            src: "images/materials-library/pic9.jpg"
        },
        {
            title: "Source: Nanotechnology 2012, 23, 385602",
            src: "images/materials-library/pic10.jpg"
        },
        {
            title: "Source: Electrochimia Acta, 2013, 107, 592",
            src: "images/materials-library/pic11.jpg"
        },
        {
            title: "Source: Cat. Sci. Tech.2013, 3, 1078",
            src: "images/materials-library/pic12.jpg"
        },
        {
            title: "Source: RSC Advance, 2013, 3, 25858",
            src: "images/materials-library/pic13.jpg"
        },
        {
            title: "Source: Cat. Sci. Tech.2013, 3, 1078",
            src: "images/materials-library/pic14.jpg"
        },
        {
            title: "Source: J. Mater. Chem. A.2014, 2, 17848",
            src: "images/materials-library/pic15.jpg"
        },
        {
            title: "Source: ACS Appl. Mater. Interface2014, 6, 2692",
            src: "images/materials-library/pic16.jpg"
        },
        {
            title: "Source: Biosens. Bioelectron. 2014, 62, 357",
            src: "images/materials-library/pic17.jpg"
        },
        {
            title: "Source: J. Mater. Chem. A, 2014, 2, 2233",
            src: "images/materials-library/pic18.jpg"
        },
        {
            title: "Source: ACS Appl. Mater. Interface, 2013, 5, 4791",
            src: "images/materials-library/pic19.jpg"
        },
        {
            title: "Source: J. Chem. Sci. 2014",
            src: "images/materials-library/pic20.jpg"
        },
        {
            title: "Source: ChemNanoMat 2015, 1, 615",
            src: "images/materials-library/pic21.jpg"
        },
        {
            title: "Source: Electrochim. Acta, 2015, 163, 16",
            src: "images/materials-library/pic22.jpg"
        },
        {
            title: "Source: J. Mater. Chem. A 2016, 4, 587",
            src: "images/materials-library/pic23.jpg"
        },
        {
            title: "Source: J. Mater. Chem. A 2016, 4, 8384",
            src: "images/materials-library/pic24.jpg"
        },
    ]
}

const labFacilities = [
    {
        src: "images/lab/lab1.jpg",
        title: "Electrochemical Workstation CHI 842b and 643b with RDE/RRDE setup (Pine Instruments)"
    },
    {
        src: "images/lab/lab2.jpg",
        title: "Electrochemical Workstation Gamry 3000 (GAMRY INC)"
    },
    {
        src: "images/lab/lab3.jpg",
        title: "Battery Tester System (NEWARE) "
    },
    {
        src: "images/lab/lab4.jpg",
        title: "Flow Injection "
    },
    {
        src: "images/lab/lab5.jpg",
        title: "HPLC (ThermoFischer Scientific)"
    },
    {
        src: "images/lab/lab6.jpg",
        title: "Glove Box (mBRAUN) "
    },
    {
        src: "images/lab/lab7.jpg",
        title: "Electrochemical Workstation Autolab with RDE/RRDE setup (Pine Instruments)"
    },
    {
        src: "images/lab/lab8.jpg",
        title: "Electrochemical Workstation CHI 400A and CHI 843b"
    },
    {
        src: "images/lab/lab9.jpg",
        title: "Micro Centrifuge ( TARSONS)"
    },
    {
        src: "images/lab/lab10.jpg",
        title: "Tube Furnace (Ants Ceramics )"
    },
    {
        src: "images/lab/lab11.jpg",
        title: "Film Coater ( GELON )"
    },
    {
        src: "images/lab/lab12.jpg",
        title: "Battery press and Crimper (Gelon)"
    },
    {
        src: "images/lab/lab13.jpg",
        title: "Fume Hood Chamber (LabGuard)"
    },
    {
        src: "images/lab/lab14.jpg",
        title: "Muffled Furnace (Ants Ceramics)"
    },
    {
        src: "images/lab/lab15.jpg",
        title: "Split Furnace (Ants Ceramics )"
    },
    {
        src: "images/lab/lab16.jpg",
        title: "Vacuum Oven (Rivotek)"
    },
]

const galleryPageImages = [
    {
        src: "images/gallery/img-1.jpg",
        title: "Group Photo, January 2024"
    },
    {
        src: "images/gallery/img-2.jpg",
        title: "Our Group Alumni M. M. Kumar, June 2024"
    },
    {
        src: "images/gallery/img-3.jpg",
        title: "Group Dinner with Prof. S. Sampath, March 2025"
    },
    {
        src: "images/gallery/img-4.jpg",
        title: "Loknath's Birthday Celebration, May 2025"
    },
    {
        src: "images/gallery/img-5.jpg",
        title: "Farewell to summer interns, May 2025"
    },
    {
        src: "images/gallery/img-6.jpg",
        title: "Our Group Alumni Dr. B K Jena, December 2024"
    },
    {
        src: "images/gallery/img-7.jpg",
        title: "Our Group Alumni Rahul Singh at Casewestern University, June 2024"
    },
    {
        src: "images/gallery/img-8.jpg",
        title: "Sir's Birthday Celebration, July 2025"
    },
    {
        src: "images/gallery/img-9.jpg",
        title: "Loknath Presenting his work, ACS Spring, March 2025"
    },
    {
        src: "images/gallery/img-10.jpg",
        title: "Our Group Alumni Dr. Sukanta Chakrabartty and Dr. Sourav Mallick, May 2025"
    },
    {
        src: "images/gallery/img-11.jpg",
        title: "Our Group Alumni Dr. Sourav Bag and his Student, July 2025"
    },
    {
        src: "images/gallery/img-12.jpg",
        title: "Santanu Ghora presenting his work at 248th ECS Meeting, October 2025"
    },
    {
        src: "images/gallery/img-13.jpeg",
        title: "Our Group Alumni Dr. Arpan Samanta, Dec 2025"
    },
    {
        src: "images/gallery/img-14.jpeg",
        title: "Sir delivering a lecture at RAPC at Department of chemistry, January 2026"
    },
    {
        src: "images/gallery/img-15.jpeg",
        title: "Our Group Alumni Dr. Barun Kumar Barman, January 2026"
    },
    {
        src: "images/gallery/img-16.jpeg",
        title: "Summer Interns Farewell, July 2026"
    },
    {
        src: "images/gallery/img-17.jpeg",
        title: "Sir's Birthday Celebration, July 2026"
    },
]


export { homepageBannerImages, galleryPageImages, team, newsDetails, publications, materialsLibrary, otherPublications, labFacilities }
